import { mutationTypes, actionTypes } from '../../../types';
import { uiComponents, uiStates } from '../../../tools/viewState';

export default {
	state: {
		type: '',
		url: '',
		isStereo: false,
	},
	mutations: {
		[mutationTypes.OPEN_VRVIEWER](state, options) {
			Object.assign(state, options);
		},
	},
	actions: {
		[actionTypes.OPEN_VRVIEWER]({ commit }, options) {
			commit(mutationTypes.viewStateSetUiState, { id: uiComponents.uiVr, uiState: uiStates.maximised });
			commit(mutationTypes.OPEN_VRVIEWER, options);
		},
	},
};
